var _rect, _path, _path2, _path3, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 15.68V12.6533C24.6667 11.7133 24.24 11.3333 23.18 11.3333H20.4867C19.4267 11.3333 19 11.7133 19 12.6533V15.6733C19 16.62 19.4267 16.9933 20.4867 16.9933H23.18C24.24 17 24.6667 16.62 24.6667 15.68Z",
    fill: "white",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 23.18V20.4867C24.6667 19.4267 24.24 19 23.18 19H20.4867C19.4267 19 19 19.4267 19 20.4867V23.18C19 24.24 19.4267 24.6667 20.4867 24.6667H23.18C24.24 24.6667 24.6667 24.24 24.6667 23.18Z",
    fill: "white",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.68V12.6533C17 11.7133 16.5733 11.3333 15.5133 11.3333H12.82C11.76 11.3333 11.3333 11.7133 11.3333 12.6533V15.6733C11.3333 16.62 11.76 16.9933 12.82 16.9933H15.5133C16.5733 17 17 16.62 17 15.68Z",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.18V20.4867C17 19.4267 16.5733 19 15.5133 19H12.82C11.76 19 11.3333 19.4267 11.3333 20.4867V23.18C11.3333 24.24 11.76 24.6667 12.82 24.6667H15.5133C16.5733 24.6667 17 24.24 17 23.18Z",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#5444F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburg);
export default __webpack_public_path__ + "static/media/hamburg.6706f62b147a0fbfdf79001ebe6bf54f.svg";
export { ForwardRef as ReactComponent };